import { render, staticRenderFns } from "./ComplieAddModelLink.vue?vue&type=template&id=3f822ed8&scoped=true"
import script from "./ComplieAddModelLink.vue?vue&type=script&lang=js"
export * from "./ComplieAddModelLink.vue?vue&type=script&lang=js"
import style0 from "./ComplieAddModelLink.vue?vue&type=style&index=0&id=3f822ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f822ed8",
  null
  
)

export default component.exports